import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import { useNotifications } from "utils/hooks";
import { notification_color_keys } from "utils/hooks";
import { api } from "data";

export const useHandleQuestionOrderChange = ({ listing_uuid, type }) => {
  const { notify } = useNotifications();

  const payload = {
    listing_uuid: listing_uuid,
    type: type,
  };

  const { mutate: postQuestionOrder } = useCustomMutation({
    url: api.questions.reorder_questions,
    onSuccess: () => {
      notify(
        "Questions reordered Successfully !",
        notification_color_keys.success
      );
    },
  });

  const handleOrderChange = (
    updatedOfferingsOrder,
    oldOfferingsOrder,
    setOfferings
  ) => {
    const orderMap = {};
    updatedOfferingsOrder.forEach(({ uuid }, index) => {
      orderMap[uuid] = index;
    });
    payload.order_map = orderMap;

    postQuestionOrder(payload, {
      onError: (error) => {
        setOfferings(oldOfferingsOrder);
        notify(
          error?.message ??
            "Error reordering booking questions, please try again",
          notification_color_keys.error
        );
      },
    });
  };

  return { handleOrderChange };
};
